import { Component, OnInit } from '@angular/core';
import { Projecttemplate } from './model/projecttemplate';
import { OrgtemplatelistService } from './service/orgtemplatelist.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-orgtemplatelist',
  templateUrl: './orgtemplatelist.component.html',
  styleUrls: ['./orgtemplatelist.component.css']
})
export class OrgtemplatelistComponent implements OnInit {
  templateList:Projecttemplate[];
  choosenTemplate:Projecttemplate;
  constructor(private otlsrv:OrgtemplatelistService) { }

  ngOnInit() {
    this.choosenTemplate = new Projecttemplate;
    this.otlsrv.getProjectTemplates().pipe(untilDestroyed(this)).subscribe(ptl =>{
      this.templateList = ptl;
    });
  }
  setTemplate(template:Projecttemplate){
    this.choosenTemplate = template;
  }
  deleteTemplate(){
    this.otlsrv.deleteTemplate(this.choosenTemplate).pipe(untilDestroyed(this)).subscribe(result => {
      //console.log('Template deleted',result);
      //remove from UI list
      this.templateList.splice(this.templateList.indexOf(this.choosenTemplate),1)
      
    });
  }

}
